import { isResourceName } from '@spotify/confidence-core-react';

import { parseTimestamp } from '../helpers';
import type { RecordingReference } from './types';

const parseTimeFragment = (
  fragment: string,
): Pick<RecordingReference, 'startTime' | 'endTime'> => {
  const separatorIndex = fragment.indexOf('-');
  if (separatorIndex === -1) {
    const startTime = parseTimestamp(fragment);
    return startTime !== undefined ? { startTime } : {};
  }
  const startPart = fragment.slice(0, separatorIndex);
  const endPart = fragment.slice(separatorIndex + 1);
  const startTime = startPart ? parseTimestamp(startPart) : undefined;
  const endTime = endPart ? parseTimestamp(endPart) : undefined;
  if (startTime === undefined && endTime === undefined) return {};
  return { startTime, endTime };
};

export const parseRecordingReferences = (
  content: string,
): RecordingReference[] => {
  const references: RecordingReference[] = [];
  const seen = new Set<string>();

  for (const line of content.split('\n')) {
    const trimmed = line.trim();
    if (!trimmed) continue;

    const hashIndex = trimmed.indexOf('#');
    const name = hashIndex === -1 ? trimmed : trimmed.slice(0, hashIndex);

    if (!isResourceName(name, 'recordings') || seen.has(trimmed)) continue;
    seen.add(trimmed);

    const timeInfo =
      hashIndex !== -1 ? parseTimeFragment(trimmed.slice(hashIndex + 1)) : {};

    references.push({ name, ...timeInfo });
  }

  return references;
};
